import React from 'react'
import "./Loader.scss"
import { LazyLoadImage } from 'react-lazy-load-image-component';
import LoaderIcon from "../../Icons/sport-icons/cricketIcon.svg"
const Loader = () => {
  return <>
  
  <div className="iframe-loader_">
    <div className="iframe-loader-content_">
            <LazyLoadImage src={LoaderIcon} className="_loader-loader-logo_" />
            <LazyLoadImage src={LoaderIcon} className="_loader-loader-logo_" />
             <LazyLoadImage src={LoaderIcon} className="_loader-loader-logo_" />
    </div>
  </div>
  </>
}

export default Loader